import React, { useState } from "react";

const SidingSelector = ({ canEdit, value, onChange }) => {
  const [loading, setLoading] = useState(false);
  const [selectedColor, setSelectedColor] = useState("");
  const [trimColor, setTrimColor] = useState("");
  const [fasciaColor, setFasciaColor] = useState("");
  const [soffitColor, setSoffitColor] = useState("");
  const [dripEdgeColor, setDripEdgeColor] = useState("");
  const [trimSize, setTrimSize] = useState("");
  const [showColors, setShowColors] = useState(true);
  const [showTrimColors, setShowTrimColors] = useState(true);
  const [showTrimSizes, setShowTrimSizes] = useState(true);
  const [showShutters, setShowShutters] = useState(true);
  const [hasShutters, setHasShutters] = useState("");
  const [showFasciaColors, setShowFasciaColors] = useState(true);
  const [showSoffitColors, setShowSoffitColors] = useState(true);
  const [showDripEdgeColors, setShowDripEdgeColors] = useState(true);

  const sidingOptions = [
    {
      name: "Double 4 Siding",
      description: "Durable, low-maintenance vinyl lap siding in various colors",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/lap-siding.jpg",
      hasColors: true,
      colors: [
        { name: "White", code: "#FFFFFF" },
        { name: "Cream", code: "#F5F5DC" },
        { name: "Beige", code: "#D4C5B9" },
        { name: "Light Gray", code: "#D3D3D3" },
        { name: "Medium Gray", code: "#A9A9A9" },
        { name: "Charcoal", code: "#4A4A4A" },
        { name: "Navy Blue", code: "#1C3A5C" },
        { name: "Slate Blue", code: "#6A7B8C" },
        { name: "Sage Green", code: "#B2C2A3" },
        { name: "Forest Green", code: "#3B5F4A" },
        { name: "Light Brown", code: "#C8A882" },
        { name: "Dark Brown", code: "#5D4E37" },
        { name: "Clay", code: "#B97A57" },
        { name: "Terracotta", code: "#C76846" },
        { name: "Sandstone", code: "#D4AF88" },
      ]
    },
    {
      name: "Shake Siding",
      description: "Cedar shake appearance with low maintenance vinyl",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/shake.jpg",
      hasColors: true,
      colors: [
        { name: "White", code: "#FFFFFF" },
        { name: "Pearl", code: "#F7F3ED" },
        { name: "Cream", code: "#F5F5DC" },
        { name: "Almond", code: "#EFD9C1" },
        { name: "Sandstone", code: "#D4C5B0" },
        { name: "Clay", code: "#C8A882" },
        { name: "Adobe", code: "#B89968" },
        { name: "Sagebrush", code: "#A8A88A" },
        { name: "Gray", code: "#BEBEBE" },
        { name: "Pewter", code: "#A5A5A5" },
        { name: "Slate", code: "#6F7578" },
        { name: "Charcoal", code: "#54585A" },
        { name: "Weathered Cedar", code: "#9B8B7E" },
        { name: "Natural Cedar", code: "#8B7355" },
        { name: "Rustic Red Cedar", code: "#7A5647" },
        { name: "Deep Granite", code: "#4A4A4A" },
      ]
    },
    {
      name: "Board and Batten Siding",
      description: "Modern farmhouse style with vertical panels",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/bnb.jpg",
      hasColors: true,
      colors: [
        { name: "White", code: "#FFFFFF" },
        { name: "Linen", code: "#F5F0E8" },
        { name: "Champagne", code: "#E8DCC8" },
        { name: "Sand", code: "#D9C6A8" },
        { name: "Pewter", code: "#B8B5B0" },
        { name: "Sterling", code: "#A5A5A5" },
        { name: "Slate Gray", code: "#6F7578" },
        { name: "Graphite", code: "#4A4A4A" },
        { name: "Midnight Blue", code: "#2B3E50" },
        { name: "Harbor Blue", code: "#4A6B7C" },
        { name: "Storm Blue", code: "#5C7A8C" },
        { name: "Sage", code: "#9BAA8F" },
        { name: "Olive Green", code: "#6B7456" },
        { name: "Forest", code: "#3B4F3A" },
        { name: "Clay", code: "#B5855A" },
        { name: "Cedar", code: "#8B6F47" },
        { name: "Walnut", code: "#6B5444" },
        { name: "Barn Red", code: "#7C3C33" },
      ]
    },
  ];

  const trimOptions = [
    { name: "White", code: "#FFFFFF" },
    { name: "Black", code: "#000000" },
    { name: "Cedar Cleared", code: "#D4A574" },
    { name: "Cedar Stained", code: "#8B6F47" },
  ];

  const fasciaOptions = [
    { name: "Black", image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Black.jpg" },
    { name: "Brown", image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Brown.jpg" },
    { name: "Champagne", image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Champangne.jpg" },
    { name: "Clay", image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Clay.jpg" },
    { name: "Cottage Red", image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Cottage_Red.jpg" },
    { name: "Cozy Cottage", image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Cozy_Cottage.jpg" },
    { name: "Desert Tan", image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Desert_Tan.jpg" },
    { name: "Eggshell", image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Eggshell.jpg" },
    { name: "White", image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/White.jpg" },
  ];

  const trimSizeOptions = [
    { name: "1x6"},
    { name: "1x8" },
    { name: "1x10"},
    { name: "1x12"},
  ];

  // Parse value format: "SidingType - Color | TrimColor | TrimSize | Shutters | FasciaColor | SoffitColor"
  const parseValue = (val) => {
    if (!val) return { sidingType: "", sidingColor: "", trim: "", size: "", shutters: "", fascia: "", soffit: "", dripEdge: "" };
    
    const parts = val.split(" | ");
    const [sidingPart, trimPart, sizePart, shuttersPart, fasciaPart, soffitPart, dripEdgePart] = parts;
    const [sidingType, sidingColor] = sidingPart?.split(" - ") || ["", ""];
    
    return {
      sidingType: sidingType || "",
      sidingColor: sidingColor || "",
      trim: trimPart || "",
      size: sizePart || "",
      shutters: shuttersPart || "",
      fascia: fasciaPart || "",
      soffit: soffitPart || "",
      dripEdgeColor: dripEdgePart || "",
    };
  };

  const buildValue = (sidingType, sidingColor, trim, size, shutters, fascia, soffit, dripEdge) => {
    let result = sidingType;
    if (sidingColor) result += ` - ${sidingColor}`;
    if (trim) result += ` | ${trim}`;
    if (size) result += ` | ${size}`;
    if (shutters) result += ` | ${shutters}`;
    if (fascia) result += ` | ${fascia}`;
    if (soffit) result += ` | ${soffit}`;
    if (dripEdge) result += ` | ${dripEdge}`;
    return result;
  };

  const { sidingType, sidingColor, trim, size, shutters, fascia, soffit, dripEdge } = parseValue(value);
  const selectedSiding = sidingOptions.find((s) => s.name === sidingType);

  const handleSidingChange = (sidingName) => {
    onChange(buildValue(sidingName, "", "", "", "", ""));
    setSelectedColor("");
    setTrimColor("");
    setTrimSize("");
    setHasShutters("");
    setFasciaColor("");
    setSoffitColor("");
    setDripEdgeColor("");
    setLoading(true);
  };

  const handleColorSelect = (colorName) => {
    setSelectedColor(colorName);
    onChange(buildValue(sidingType, colorName, trimColor, trimSize, hasShutters, fasciaColor, soffitColor, dripEdgeColor));
    setShowColors(false);
  };

  const handleTrimChange = (trimName) => {
    setTrimColor(trimName);
    onChange(buildValue(sidingType, selectedColor, trimName, trimSize, hasShutters, fasciaColor, soffitColor, dripEdgeColor));
    setShowTrimColors(false);
  };

  const handleTrimSizeChange = (sizeName) => {
    setTrimSize(sizeName);
    onChange(buildValue(sidingType, selectedColor, trimColor, sizeName, hasShutters, fasciaColor, soffitColor, dripEdgeColor));
    setShowTrimSizes(false);
  };

  const handleShuttersChange = (shutterValue) => {
    setHasShutters(shutterValue);
    onChange(buildValue(sidingType, selectedColor, trimColor, trimSize, shutterValue, fasciaColor, soffitColor, dripEdgeColor));
    setShowShutters(false);
  };

  const handleFasciaColorChange = (fasciaValue) => {
    setFasciaColor(fasciaValue);
    onChange(buildValue(sidingType, selectedColor, trimColor, trimSize, hasShutters, fasciaValue, soffitColor, dripEdgeColor));
    setShowFasciaColors(false);
  };

  const handleSoffitColorChange = (soffitValue) => {
    setSoffitColor(soffitValue);
    onChange(buildValue(sidingType, selectedColor, trimColor, trimSize, hasShutters, fasciaColor, soffitValue, dripEdgeColor));
    setShowSoffitColors(false);
  };

  const handleDripEdgeColorChange = (dripEdgeValue) => {
    setDripEdgeColor(dripEdgeValue);
    onChange(buildValue(sidingType, selectedColor, trimColor, trimSize, hasShutters, fasciaColor, soffitColor, dripEdgeValue));
    setShowDripEdgeColors(false);
  };

  // Initialize state from value
  React.useEffect(() => {
    const { sidingColor: color, trim, size, shutters, fascia, soffit, dripEdgeColor } = parseValue(value);
    setSelectedColor(color);
    setTrimColor(trim);
    setTrimSize(size);
    setHasShutters(shutters);
    setFasciaColor(fascia);
    setSoffitColor(soffit);
    setDripEdgeColor(dripEdgeColor);
  }, [value]);

  return (
    <div style={{ marginBottom: "2rem" }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          gap: "2rem",
          marginTop: "1rem",
        }}
      >
        {/* LEFT SIDE: Dropdown */}
        <div style={{ flex: "1 1 280px", minWidth: "250px" }}>
          <p style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333'
          }}>
            Siding Options
          </p>
          <p style={{ fontSize: "0.9rem", color: "#555", marginBottom: "1rem" }}>
            Select a siding type to view details and preview.
          </p>

          <select
            value={sidingType}
            onChange={(e) => handleSidingChange(e.target.value)}
            disabled={!canEdit}
            style={{
              width: "100%",
              padding: "0.6rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "1rem",
              backgroundColor: "white",
              cursor: canEdit ? "pointer" : "not-allowed",
            }}
          >
            <option value="">-- Select Siding Type --</option>
            {sidingOptions.map((siding) => (
              <option key={siding.name} value={siding.name}>
                {siding.name}
              </option>
            ))}
          </select>

          {selectedSiding && (
            <div
              style={{
                marginTop: "1rem",
                padding: "1rem",
                backgroundColor: "#f8f9fa",
                borderRadius: "6px",
                border: "1px solid #dee2e6",
              }}
            >
              <p style={{ margin: 0, fontSize: "0.9rem", color: "#666" }}>
                {selectedSiding.description}
              </p>
            </div>
          )}
        </div>

        {/* RIGHT SIDE: Siding preview */}
        <div
          style={{
            flex: "1 1 300px",
            minWidth: "250px",
            textAlign: "center",
            position: "relative",
          }}
        >
          {selectedSiding ? (
            <>
              {loading && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 2,
                  }}
                >
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      border: "4px solid #ccc",
                      borderTop: "4px solid #007bff",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  ></div>
                </div>
              )}

              <img
                src={selectedSiding.image}
                alt={selectedSiding.name}
                onLoad={() => setLoading(false)}
                onError={() => setLoading(false)}
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  opacity: loading ? 0.3 : 1,
                  transition: "opacity 0.3s ease",
                }}
              />

              <div
                style={{
                  marginTop: "0.5rem",
                  fontWeight: "bold",
                  color: "#333",
                  fontSize: "1.1rem",
                }}
              >
                {selectedSiding.name}
                {selectedColor && (
                  <span style={{ color: "#007bff", fontSize: "0.95rem" }}>
                    {" "}- {selectedColor}
                  </span>
                )}
                {trimColor && (
                  <span style={{ color: "#28a745", fontSize: "0.85rem", display: "block", marginTop: "0.25rem" }}>
                    Trim: {trimColor}
                  </span>
                )}
                {trimSize && (
                  <span style={{ color: "#6c757d", fontSize: "0.85rem", display: "block", marginTop: "0.25rem" }}>
                    Size: {trimSize}
                  </span>
                )}
                {hasShutters && (
                  <span style={{ color: "#6c757d", fontSize: "0.85rem", display: "block", marginTop: "0.25rem" }}>
                    Shutters: {hasShutters}
                  </span>
                )}
                {fasciaColor && (
                  <span style={{ color: "#6c757d", fontSize: "0.85rem", display: "block", marginTop: "0.25rem" }}>
                    Fascia: {fasciaColor}
                  </span>
                )}
                {soffitColor && (
                  <span style={{ color: "#6c757d", fontSize: "0.85rem", display: "block", marginTop: "0.25rem" }}>
                    Soffit: {soffitColor}
                  </span>
                )}
              </div>
            </>
          ) : (
            <div
              style={{
                color: "#777",
                fontStyle: "italic",
                marginTop: "2rem",
                padding: "3rem",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                border: "1px dashed #ccc",
              }}
            >
              Select a siding option to preview
            </div>
          )}
        </div>
      </div>

      {/* Color Swatches for Siding */}
      {selectedSiding?.hasColors && (
        <div style={{ marginTop: "2rem", padding: "1.5rem", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #dee2e6" }}>
          <div 
            onClick={() => setShowColors(!showColors)}
            style={{ 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "space-between",
              cursor: "pointer",
              userSelect: "none"
            }}
          >
            <div>
              <h4 style={{ margin: "0 0 0.25rem 0", fontSize: "1rem", fontWeight: "600", color: "#333" }}>
                Select Siding Color
                {selectedColor && (
                  <span style={{ color: "#007bff", fontSize: "0.9rem", fontWeight: "normal", marginLeft: "0.5rem" }}>
                    ({selectedColor})
                  </span>
                )}
              </h4>
              <p style={{ fontSize: "0.9rem", color: "#666", margin: 0 }}>
                Choose from available siding colors
              </p>
            </div>
            <span style={{ fontSize: "1.5rem", color: "#666" }}>
              {showColors ? "⌄" : "^"}
            </span>
          </div>
          
          {showColors && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
                  gap: "1rem",
                  marginTop: "1rem"
                }}
              >
                {selectedSiding.colors.map((color) => (
                  <div
                    key={color.name}
                    onClick={() => canEdit && handleColorSelect(color.name)}
                    style={{
                      cursor: canEdit ? "pointer" : "not-allowed",
                      textAlign: "center",
                      opacity: !canEdit ? 0.6 : 1,
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "80px",
                        backgroundColor: color.code,
                        borderRadius: "8px",
                        border: selectedColor === color.name ? "3px solid #007bff" : "2px solid #ddd",
                        boxShadow: selectedColor === color.name ? "0 4px 12px rgba(0,123,255,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
                        transition: "all 0.2s",
                        transform: selectedColor === color.name ? "scale(1.05)" : "scale(1)",
                      }}
                    />
                    <p
                      style={{
                        margin: "0.5rem 0 0 0",
                        fontSize: "0.8rem",
                        color: selectedColor === color.name ? "#007bff" : "#333",
                        fontWeight: selectedColor === color.name ? "600" : "400",
                      }}
                    >
                      {color.name}
                    </p>
                    {selectedColor === color.name && (
                      <span style={{ fontSize: "0.7rem", color: "#007bff" }}>✓ Selected</span>
                    )}
                  </div>
                ))}
              </div>

              {!canEdit && (
                <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#dc3545", fontStyle: "italic" }}>
                  Color selection is locked. Contact administrator to make changes.
                </p>
              )}
            </>
          )}
        </div>
      )}

      {/* Trim Color Selection */}
      {selectedSiding && (
        <div style={{ marginTop: "2rem", padding: "1.5rem", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #dee2e6" }}>
          <div 
            onClick={() => setShowTrimColors(!showTrimColors)}
            style={{ 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "space-between",
              cursor: "pointer",
              userSelect: "none"
            }}
          >
            <div>
              <h4 style={{ margin: "0 0 0.25rem 0", fontSize: "1rem", fontWeight: "600", color: "#333" }}>
                Select Trim Color
                {trimColor && (
                  <span style={{ color: "#28a745", fontSize: "0.9rem", fontWeight: "normal", marginLeft: "0.5rem" }}>
                    ({trimColor})
                  </span>
                )}
              </h4>
              <p style={{ fontSize: "0.9rem", color: "#666", margin: 0 }}>
                Choose a trim color to complement your siding
              </p>
            </div>
            <span style={{ fontSize: "1.5rem", color: "#666" }}>
              {showTrimColors ? "⌄" : "^"}
            </span>
          </div>
          
          {showTrimColors && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                  gap: "1rem",
                  marginTop: "1rem"
                }}
              >
                {trimOptions.map((trim) => (
                  <label
                    key={trim.name}
                    style={{
                      cursor: canEdit ? "pointer" : "not-allowed",
                      display: "block",
                      opacity: !canEdit ? 0.6 : 1,
                    }}
                  >
                    <input
                      type="radio"
                      name="trimColor"
                      value={trim.name}
                      checked={trimColor === trim.name}
                      onChange={(e) => canEdit && handleTrimChange(e.target.value)}
                      disabled={!canEdit}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        height: "80px",
                        backgroundColor: trim.code,
                        borderRadius: "8px",
                        border: trimColor === trim.name ? "3px solid #28a745" : "2px solid #ddd",
                        boxShadow: trimColor === trim.name ? "0 4px 12px rgba(40,167,69,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
                        transition: "all 0.2s",
                        transform: trimColor === trim.name ? "scale(1.05)" : "scale(1)",
                        position: "relative",
                      }}
                    >
                      {trimColor === trim.name && (
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "#28a745",
                            color: "white",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          ✓
                        </div>
                      )}
                    </div>
                    <p
                      style={{
                        margin: "0.5rem 0 0 0",
                        fontSize: "0.85rem",
                        color: trimColor === trim.name ? "#28a745" : "#333",
                        fontWeight: trimColor === trim.name ? "600" : "400",
                        textAlign: "center",
                      }}
                    >
                      {trim.name}
                    </p>
                  </label>
                ))}
              </div>

              {!canEdit && (
                <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#dc3545", fontStyle: "italic" }}>
                  Trim selection is locked. Contact administrator to make changes.
                </p>
              )}
            </>
          )}
        </div>
      )}

      {/* Trim Size Selection */}
      {selectedSiding && (
        <div style={{ marginTop: "2rem", padding: "1.5rem", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #dee2e6" }}>
          <div 
            onClick={() => setShowTrimSizes(!showTrimSizes)}
            style={{ 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "space-between",
              cursor: "pointer",
              userSelect: "none"
            }}
          >
            <div>
              <h4 style={{ margin: "0 0 0.25rem 0", fontSize: "1rem", fontWeight: "600", color: "#333" }}>
                Select Trim Size
                {trimSize && (
                  <span style={{ color: "#28a745", fontSize: "0.9rem", fontWeight: "normal", marginLeft: "0.5rem" }}>
                    ({trimSize})
                  </span>
                )}
              </h4>
              <p style={{ fontSize: "0.9rem", color: "#666", margin: 0 }}>
                Choose a trim size to complement your siding
              </p>
            </div>
            <span style={{ fontSize: "1.5rem", color: "#666" }}>
              {showTrimSizes ? "⌄" : "^"}
            </span>
          </div>
          
          {showTrimSizes && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                  gap: "1rem",
                  marginTop: "1rem"
                }}
              >
                {trimSizeOptions.map((trim) => (
                  <label
                    key={trim.name}
                    style={{
                      cursor: canEdit ? "pointer" : "not-allowed",
                      display: "block",
                      opacity: !canEdit ? 0.6 : 1,
                    }}
                  >
                    <input
                      type="radio"
                      name="trimSize"
                      value={trim.name}
                      checked={trimSize === trim.name}
                      onChange={(e) => canEdit && handleTrimSizeChange(e.target.value)}
                      disabled={!canEdit}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        height: "80px",
                        borderRadius: "8px",
                        backgroundColor: "#f0f0f0",
                        border: trimSize === trim.name ? "3px solid #28a745" : "2px solid #ddd",
                        boxShadow: trimSize === trim.name ? "0 4px 12px rgba(40,167,69,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
                        transition: "all 0.2s",
                        transform: trimSize === trim.name ? "scale(1.05)" : "scale(1)",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#333"
                      }}
                    >
                      {trim.name}
                      {trimSize === trim.name && (
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "#28a745",
                            color: "white",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          ✓
                        </div>
                      )}
                    </div>
                    <p
                      style={{
                        margin: "0.5rem 0 0 0",
                        fontSize: "0.85rem",
                        color: trimSize === trim.name ? "#28a745" : "#333",
                        fontWeight: trimSize === trim.name ? "600" : "400",
                        textAlign: "center",
                      }}
                    >
                      {trim.name}
                    </p>
                  </label>
                ))}
              </div>

              {!canEdit && (
                <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#dc3545", fontStyle: "italic" }}>
                  Trim selection is locked. Contact administrator to make changes.
                </p>
              )}
            </>
          )}
        </div>
      )}

      {/* Shutters Selection */}
      {selectedSiding && (
        <div style={{ marginTop: "2rem", padding: "1.5rem", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #dee2e6" }}>
          <div 
            onClick={() => setShowShutters(!showShutters)}
            style={{ 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "space-between",
              cursor: "pointer",
              userSelect: "none"
            }}
          >
            <div>
              <h4 style={{ margin: "0 0 0.25rem 0", fontSize: "1rem", fontWeight: "600", color: "#333" }}>
                Do you want shutters?
                {hasShutters && (
                  <span style={{ color: "#6c757d", fontSize: "0.9rem", fontWeight: "normal", marginLeft: "0.5rem" }}>
                    ({hasShutters})
                  </span>
                )}
              </h4>
              <p style={{ fontSize: "0.9rem", color: "#666", margin: 0 }}>
                Select whether you want shutters on your home
              </p>
            </div>
            <span style={{ fontSize: "1.5rem", color: "#666" }}>
              {showShutters ? "⌄" : "^"}
            </span>
          </div>
          
          {showShutters && (
            <>
              <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
                <label
                  style={{
                    cursor: canEdit ? "pointer" : "not-allowed",
                    flex: 1,
                    opacity: !canEdit ? 0.6 : 1,
                  }}
                >
                  <input
                    type="radio"
                    name="shutters"
                    value="Yes"
                    checked={hasShutters === "Yes"}
                    onChange={(e) => canEdit && handleShuttersChange(e.target.value)}
                    disabled={!canEdit}
                    style={{
                      position: "absolute",
                      opacity: 0,
                      width: 0,
                      height: 0,
                    }}
                  />
                  <div
                    style={{
                      padding: "1.5rem",
                      borderRadius: "8px",
                      border: hasShutters === "Yes" ? "3px solid #007bff" : "2px solid #ddd",
                      backgroundColor: hasShutters === "Yes" ? "#e7f3ff" : "#fff",
                      boxShadow: hasShutters === "Yes" ? "0 4px 12px rgba(0,123,255,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
                      transition: "all 0.2s",
                      textAlign: "center",
                      fontSize: "1.1rem",
                      fontWeight: hasShutters === "Yes" ? "600" : "400",
                      color: hasShutters === "Yes" ? "#007bff" : "#333",
                    }}
                  >
                    Yes
                    {hasShutters === "Yes" && (
                      <span style={{ marginLeft: "0.5rem" }}>✓</span>
                    )}
                  </div>
                </label>

                <label
                  style={{
                    cursor: canEdit ? "pointer" : "not-allowed",
                    flex: 1,
                    opacity: !canEdit ? 0.6 : 1,
                  }}
                >
                  <input
                    type="radio"
                    name="shutters"
                    value="No"
                    checked={hasShutters === "No"}
                    onChange={(e) => canEdit && handleShuttersChange(e.target.value)}
                    disabled={!canEdit}
                    style={{
                      position: "absolute",
                      opacity: 0,
                      width: 0,
                      height: 0,
                    }}
                  />
                  <div
                    style={{
                      padding: "1.5rem",
                      borderRadius: "8px",
                      border: hasShutters === "No" ? "3px solid #007bff" : "2px solid #ddd",
                      backgroundColor: hasShutters === "No" ? "#e7f3ff" : "#fff",
                      boxShadow: hasShutters === "No" ? "0 4px 12px rgba(0,123,255,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
                      transition: "all 0.2s",
                      textAlign: "center",
                      fontSize: "1.1rem",
                      fontWeight: hasShutters === "No" ? "600" : "400",
                      color: hasShutters === "No" ? "#007bff" : "#333",
                    }}
                  >
                    No
                    {hasShutters === "No" && (
                      <span style={{ marginLeft: "0.5rem" }}>✓</span>
                    )}
                  </div>
                </label>
              </div>

              {!canEdit && (
                <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#dc3545", fontStyle: "italic" }}>
                  Shutter selection is locked. Contact administrator to make changes.
                </p>
              )}
            </>
          )}
        </div>
      )}

      {/* Fascia Color Selection */}
      {selectedSiding && (
        <div style={{ marginTop: "2rem", padding: "1.5rem", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #dee2e6" }}>
          <div 
            onClick={() => setShowFasciaColors(!showFasciaColors)}
            style={{ 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "space-between",
              cursor: "pointer",
              userSelect: "none"
            }}
          >
            <div>
              <h4 style={{ margin: "0 0 0.25rem 0", fontSize: "1rem", fontWeight: "600", color: "#333" }}>
                Select Fascia Color
                {fasciaColor && (
                  <span style={{ color: "#28a745", fontSize: "0.9rem", fontWeight: "normal", marginLeft: "0.5rem" }}>
                    ({fasciaColor})
                  </span>
                )}
              </h4>
              <p style={{ fontSize: "0.9rem", color: "#666", margin: 0 }}>
                Choose a fascia color to complement your siding
              </p>
            </div>
            <span style={{ fontSize: "1.5rem", color: "#666" }}>
              {showFasciaColors ? "⌄" : "^"}
            </span>
          </div>
          
          {showFasciaColors && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                  gap: "1rem",
                  marginTop: "1rem"
                }}
              >
                {fasciaOptions.map((fascia) => (
                  <label
                    key={fascia.name}
                    style={{
                      cursor: canEdit ? "pointer" : "not-allowed",
                      display: "block",
                      opacity: !canEdit ? 0.6 : 1,
                    }}
                  >
                    <input
                      type="radio"
                      name="fasciaColor"
                      value={fascia.name}
                      checked={fasciaColor === fascia.name}
                      onChange={(e) => canEdit && handleFasciaColorChange(e.target.value)}
                      disabled={!canEdit}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        height: "100px",
                        borderRadius: "8px",
                        border: fasciaColor === fascia.name ? "3px solid #28a745" : "2px solid #ddd",
                        boxShadow: fasciaColor === fascia.name ? "0 4px 12px rgba(40,167,69,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
                        transition: "all 0.2s",
                        transform: fasciaColor === fascia.name ? "scale(1.05)" : "scale(1)",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={fascia.image}
                        alt={fascia.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      {fasciaColor === fascia.name && (
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "#28a745",
                            color: "white",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          ✓
                        </div>
                      )}
                    </div>
                    <p
                      style={{
                        margin: "0.5rem 0 0 0",
                        fontSize: "0.85rem",
                        color: fasciaColor === fascia.name ? "#28a745" : "#333",
                        fontWeight: fasciaColor === fascia.name ? "600" : "400",
                        textAlign: "center",
                      }}
                    >
                      {fascia.name}
                    </p>
                  </label>
                ))}
              </div>

              {!canEdit && (
                <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#dc3545", fontStyle: "italic" }}>
                  Fascia selection is locked. Contact administrator to make changes.
                </p>
              )}
            </>
          )}
        </div>
      )}

      {/* Soffit Color Selection */}
      {selectedSiding && (
        <div style={{ marginTop: "2rem", padding: "1.5rem", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #dee2e6" }}>
          <div 
            onClick={() => setShowSoffitColors(!showSoffitColors)}
            style={{ 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "space-between",
              cursor: "pointer",
              userSelect: "none"
            }}
          >
            <div>
              <h4 style={{ margin: "0 0 0.25rem 0", fontSize: "1rem", fontWeight: "600", color: "#333" }}>
                Select Soffit Color
                {soffitColor && (
                  <span style={{ color: "#28a745", fontSize: "0.9rem", fontWeight: "normal", marginLeft: "0.5rem" }}>
                    ({soffitColor})
                  </span>
                )}
              </h4>
              <p style={{ fontSize: "0.9rem", color: "#666", margin: 0 }}>
                Choose a soffit color to complement your siding
              </p>
            </div>
            <span style={{ fontSize: "1.5rem", color: "#666" }}>
              {showSoffitColors ? "⌄" : "^"}
            </span>
          </div>
          
          {showSoffitColors && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                  gap: "1rem",
                  marginTop: "1rem"
                }}
              >
                {fasciaOptions.map((soffit) => (
                  <label
                    key={soffit.name}
                    style={{
                      cursor: canEdit ? "pointer" : "not-allowed",
                      display: "block",
                      opacity: !canEdit ? 0.6 : 1,
                    }}
                  >
                    <input
                      type="radio"
                      name="soffitColor"
                      value={soffit.name}
                      checked={soffitColor === soffit.name}
                      onChange={(e) => canEdit && handleSoffitColorChange(e.target.value)}
                      disabled={!canEdit}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        height: "100px",
                        borderRadius: "8px",
                        border: soffitColor === soffit.name ? "3px solid #28a745" : "2px solid #ddd",
                        boxShadow: soffitColor === soffit.name ? "0 4px 12px rgba(40,167,69,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
                        transition: "all 0.2s",
                        transform: soffitColor === soffit.name ? "scale(1.05)" : "scale(1)",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={soffit.image}
                        alt={soffit.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      {soffitColor === soffit.name && (
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "#28a745",
                            color: "white",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          ✓
                        </div>
                      )}
                    </div>
                    <p
                      style={{
                        margin: "0.5rem 0 0 0",
                        fontSize: "0.85rem",
                        color: soffitColor === soffit.name ? "#28a745" : "#333",
                        fontWeight: soffitColor === soffit.name ? "600" : "400",
                        textAlign: "center",
                      }}
                    >
                      {soffit.name}
                    </p>
                  </label>
                ))}
              </div>

              {!canEdit && (
                <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#dc3545", fontStyle: "italic" }}>
                  Soffit selection is locked. Contact administrator to make changes.
                </p>
              )}
            </>
          )}
        </div>
      )}

      {/* Drip Edge Color Selection */}
      {selectedSiding && (
        <div style={{ marginTop: "2rem", padding: "1.5rem", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #dee2e6" }}>
          <div 
            onClick={() => setShowDripEdgeColors(!showDripEdgeColors)}
            style={{ 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "space-between",
              cursor: "pointer",
              userSelect: "none"
            }}
          >
            <div>
              <h4 style={{ margin: "0 0 0.25rem 0", fontSize: "1rem", fontWeight: "600", color: "#333" }}>
                Select Drip Edge Color
                {dripEdgeColor && (
                  <span style={{ color: "#28a745", fontSize: "0.9rem", fontWeight: "normal", marginLeft: "0.5rem" }}>
                    ({dripEdgeColor})
                  </span>
                )}
              </h4>
              <p style={{ fontSize: "0.9rem", color: "#666", margin: 0 }}>
                Choose a drip edge color to complement your siding
              </p>
            </div>
            <span style={{ fontSize: "1.5rem", color: "#666" }}>
              {showDripEdgeColors ? "⌄" : "^"}
            </span>
          </div>
          
          {showDripEdgeColors && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                  gap: "1rem",
                  marginTop: "1rem"
                }}
              >
                {fasciaOptions.map((dripEdge) => (
                  <label
                    key={dripEdge.name}
                    style={{
                      cursor: canEdit ? "pointer" : "not-allowed",
                      display: "block",
                      opacity: !canEdit ? 0.6 : 1,
                    }}
                  >
                    <input
                      type="radio"
                      name="dripEdgeColor"
                      value={dripEdge.name}
                      checked={dripEdgeColor === dripEdge.name}
                      onChange={(e) => canEdit && handleDripEdgeColorChange(e.target.value)}
                      disabled={!canEdit}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        height: "100px",
                        borderRadius: "8px",
                        border: dripEdgeColor === dripEdge.name ? "3px solid #28a745" : "2px solid #ddd",
                        boxShadow: dripEdgeColor === dripEdge.name ? "0 4px 12px rgba(40,167,69,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
                        transition: "all 0.2s",
                        transform: dripEdgeColor === dripEdge.name ? "scale(1.05)" : "scale(1)",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={dripEdge.image}
                        alt={dripEdge.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      {dripEdgeColor === dripEdge.name && (
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "#28a745",
                            color: "white",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          ✓
                        </div>
                      )}
                    </div>
                    <p
                      style={{
                        margin: "0.5rem 0 0 0",
                        fontSize: "0.85rem",
                        color: dripEdgeColor === dripEdge.name ? "#28a745" : "#333",
                        fontWeight: dripEdgeColor === dripEdge.name ? "600" : "400",
                        textAlign: "center",
                      }}
                    >
                      {dripEdge.name}
                    </p>
                  </label>
                ))}
              </div>

              {!canEdit && (
                <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#dc3545", fontStyle: "italic" }}>
                  Drip Edge selection is locked. Contact administrator to make changes.
                </p>
              )}
            </>
          )}
        </div>
      )}

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default SidingSelector;